import * as angular from "angular";
import "./ragRangeBarChart.scss";

interface IRagBarChartBindings {
    upperRagBound: number;
    lowerRagBound: number;
    hideExample: boolean;
    exampleValue: number;
    examplePercentage: number;
    exampleUnit: string;
    exampleNoun: string;
}

class RagRangeBarChartComponentController implements angular.IComponentController, IRagBarChartBindings {

    // bindings
    upperRagBound: number = 2;
    lowerRagBound: number = 4;
    upperValue: number = 2;
    lowerValue: number = 4;
    hideExample: boolean;
    exampleValue: number;
    examplePercentage: number;
    exampleUnit: string;
    exampleNoun: string;

    // state
    showExample: boolean;
    displayPercentage: number;
    displayClass: string;
    displayLabel: string;

    constructor() { }

    $onInit(): void {
        this.render();
    }

    $onChanges(): void {
        this.render();
    }

    // ---

    private render(): void {
        this.showExample = !this.hideExample
            && !isNaN(this.exampleValue)
            && !isNaN(this.examplePercentage)
            && isFinite(this.examplePercentage);

        if (!this.showExample) {
            return;
        }

        this.displayPercentage = Number(this.examplePercentage.toFixed(2));
        this.displayClass = this.getExampleClass(this.displayPercentage);
        this.displayLabel = (this.exampleUnit === "%")
            ? `Example of ${this.exampleValue}${this.exampleUnit} ${this.exampleNoun}`
            : `Example of ${this.exampleValue} ${this.exampleUnit}`;
    }

    private getExampleClass(percentage: number): string {
        if (percentage < this.lowerRagBound) {
            return "red";
        }

        if (percentage > this.upperRagBound) {
            return "green";
        }

        return "amber";
    }
}

export class RagRangeBarChartComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean | { [index: string]: string; };

    constructor() {
        this.bindings = {
            upperRagBound: "<",
            lowerRagBound: "<",
            hideExample: "<?",
            exampleValue: "<?",
            examplePercentage: "<?",
            exampleUnit: "@",
            exampleNoun: "@",
        };

        this.transclude = true;
        this.controller = RagRangeBarChartComponentController;
        this.template = require("./ragRangeBarChart.html");
    }
}
